import { useEffect } from 'react';
import { connect } from 'react-redux';
import PDPModal from '../generic/product/PDPModal';
import { getSpicyTagsAC } from '../generic/global_state/action_creators';

const PDPModalContainer = (props) => {
  // TODO:
  // - We would never show it when props.product is null
  //   so .visible might be redundant
  useEffect(() => {
    props.getSpicyTags();
  }, []);
  // not sure if another consumer is actually passing onClose, but the issue is that togglePdpModal doesn't
  // map to the onClose prop in PDPModal; because we're spreading props here, this is to hedge against
  // another consuming passing the onClose prop and incorrectly mapping it to togglePdpModal
  return props.product ? (
    <PDPModal {...props} onClose={props.onClose || props.togglePdpModal} />
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    spicyTags: state.tag.spicyTags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSpicyTags: () => dispatch(getSpicyTagsAC()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PDPModalContainer);
